export default {
      id: "eye-slash-usage",
      viewBox: "0 0 29 24",
      url: __webpack_public_path__ + "sprite-46b249.svg#eye-slash-usage",
      toString: function () {
        return this.url;
      }
    }